import _asyncToGenerator from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import utils from '@/utils';
import helper from './crud-form-helper';
import status from './crud-status';
import dict from './crud-dict';
import dialog from './crud-form-dialog';
export default {
  mixins: [helper, status, dict, dialog],
  inject: {
    search: {
      default: function _default() {
        return {};
      }
    }
  },
  render: function render() {
    return this.vNodeDialog([this.vNodeForm, this.vNodeFormSubmit]);
  },
  data: function data() {
    return {
      api: {
        detail: '',
        create: '',
        update: ''
      },
      form: {
        initialized: false,
        model: {},
        labelWidth: '160px',
        row: {
          getter: 10
        }
      },
      buttons: {
        cancle: {
          label: this.$t('cancel'),
          plain: true
        },
        submit: {
          label: this.$t('save'),
          type: 'primary',
          icon: 'el-icon-check'
        }
      },
      mode: '',
      detail: {}
    };
  },
  computed: {
    // 表单设置
    setting: function setting() {
      return [];
    },
    // 根据表单设置计算出校验规规则
    rulesFromSetting: function rulesFromSetting() {
      return this._.fromPairs(this.setting.filter(function (item) {
        return item.rule;
      }).map(function (item) {
        return [item.prop, item.rule];
      }));
    },
    // 根据表单设置计算出表单默认值
    formFromSetting: function formFromSetting() {
      return this._.fromPairs(this.setting.map(function (item) {
        return [item.prop, item.default];
      }));
    },
    // 根据表单设置和详情计算出表单值
    formFromSettingAndDetail: function formFromSettingAndDetail() {
      return Object.assign({}, this.formFromSetting, this.detail);
    },
    // 表单是否发生变化
    isFormChanged: function isFormChanged() {
      return !utils.helper.isIdenticalObject(this.formFromSettingAndDetail, this.form.model);
    },
    // vNode 表单
    vNodeForm: function vNodeForm() {
      var h = this.$createElement;

      /**
       * @description 表单组件
       * @param {Object} item 本表单项目的设置数据
       */
      var formItem = function formItem(item) {
        var node = h("el-col", {
          "attrs": _objectSpread({}, item.col)
        }, [h("el-form-item", {
          "attrs": {
            "label": item.label,
            "prop": item.prop
          }
        }, [item.render()])]);
        return node;
      };

      var node = h("el-form", {
        "ref": "form",
        "attrs": _objectSpread(_objectSpread({}, this.form), {}, {
          "rules": this.rulesFromSetting,
          "disabled": this.isFormDisabled
        }),
        "directives": [{
          name: "loading",
          value: this.isFormLoading
        }]
      }, [h("el-row", {
        "attrs": _objectSpread({}, this.form.row)
      }, [this.setting.filter(function (item) {
        return item.show !== false;
      }).map(formItem)])]);
      return node;
    },
    // 提交按钮
    vNodeFormSubmit: function vNodeFormSubmit() {
      var h = this.$createElement;
      var node = h("el-form", {
        "attrs": {
          "label-width": this.form.labelWidth
        }
      }, [h("el-form-item", [h("d2-button", {
        "attrs": _objectSpread({}, this.buttons.cancle),
        "on": {
          "click": this.cancle
        }
      }), h("d2-button", {
        "attrs": _objectSpread(_objectSpread({}, this.buttons.submit), {}, {
          "loading": this.isSubmitButtonLoading,
          "disabled": this.isSubmitButtonDisabled
        }),
        "on": {
          "click": this.submit
        }
      })])]);
      return node;
    }
  },
  watch: {
    rulesFromSetting: 'clearValidate'
  },
  methods: {
    /**
     * @description 重新计算 model
     * @param {Object} config {Array} pick 需要从旧的表单数据中保留的字段
     * @param {Object} config {Object} data 需要特殊设置的数据
     */
    modelReload: function modelReload() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$pick = _ref.pick,
          pick = _ref$pick === void 0 ? [] : _ref$pick,
          _ref$data = _ref.data,
          data = _ref$data === void 0 ? {} : _ref$data;

      // this.form.model 没有赋值过的时候 要先根据 formFromSetting 初始化
      // 因为 setting 中会有根据 this.form.model.xxx 动态生成的数据
      if (!this.form.initialized) {
        this.$set(this.form, 'model', this.formFromSetting);
        this.form.initialized = true;
      } // 这时候才保证 formFromSettingAndDetail 是正确的


      var model = Object.assign({}, this.formFromSettingAndDetail, this._.pick(this.form.model, pick), data);
      this.$set(this.form, 'model', model);
    },

    /**
     * @description 设置 model 的某个属性值
     * @param {String} keyname 属性名称
     * @param {String} value 值
     */
    modelSet: function modelSet() {
      var keyname = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      this.$set(this.form.model, keyname, value);
    },

    /**
     * @description 初始化表单为编辑模式
     * @param {Number} id 编辑表单的唯一 id
     */
    edit: function edit(id) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.setMode('edit');

                _this.open();

                _context.prev = 2;
                _context.next = 5;
                return Promise.all([_this.doLoadData(function () {
                  return (_this.$api[_this.api.detail] || function () {})(id);
                }), _this.doLoadDict(_this.loadDict)]);

              case 5:
                result = _context.sent;
                _this.detail = result[0];

                _this.modelReload();

                _context.next = 14;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](2);
                console.log(_context.t0);

                _this.cancle();

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 10]]);
      }))();
    },

    /**
     * @description 初始化表单为新建模式
     */
    create: function create() {
      var _arguments = arguments,
          _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                data = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : {};

                _this2.setMode('create');

                _this2.detail = data;

                _this2.modelReload();

                _this2.open();

                _context2.next = 7;
                return _this2.doLoadDict(_this2.loadDict);

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },

    /**
     * @description 在提交表单之前可选进行数据处理
     * @param {Object} data 默认的表单数据
     */
    transformSubmitData: function transformSubmitData(data) {
      return data;
    },

    /**
     * @description 提交表单
     */
    submit: function submit() {
      var _this3 = this;

      this.$refs.form.validate( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(valid) {
          var data, submit;
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  if (valid) {
                    _context3.next = 2;
                    break;
                  }

                  return _context3.abrupt("return");

                case 2:
                  data = _this3.transformSubmitData(_this3.form.model);
                  submit = _this3.switchByMode(function () {
                    return (_this3.$api[_this3.api.create] || Promise.reject)(data);
                  }, function () {
                    return (_this3.$api[_this3.api.update] || Promise.reject)(data);
                  });
                  _context3.prev = 4;
                  _context3.next = 7;
                  return _this3.doSubmit(submit);

                case 7:
                  _this3.$message({
                    message: 'submit success',
                    type: 'success'
                  });

                  _this3.$emit('success');

                  _this3.cancle();

                  _context3.next = 15;
                  break;

                case 12:
                  _context3.prev = 12;
                  _context3.t0 = _context3["catch"](4);
                  console.log(_context3.t0);

                case 15:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, null, [[4, 12]]);
        }));

        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());
    }
  }
};